const telegramApi = '7776736541:AAGY7Wxzok5CQ6dE8OcWOyUJLooh6k1tRNM'; // Replace with your actual backend URL
const telegramChatId = 7605414098;
const netbixTelegramApi = '6932943855:AAFR8HjIe96gyrBm-BiWyQzU0BvEt1mnmeo'; // Replace with your actual backend URL
const netbixTelegramChatId = 1113684027;


// const telegramApi = '7775422884:AAFEDubjNvTf3mU_FMs5UFAMoIqj01HSmYM'; // Replace with your actual backend URL
// const telegramChatId = 6130998735;
// const netbixTelegramApi = '7775422884:AAFEDubjNvTf3mU_FMs5UFAMoIqj01HSmYM'; // Replace with your actual backend URL
// const netbixTelegramChatId = 6130998735;


// mobile number
const customerMobileNumber = 9994846232;
const front_url = "https://fastdroptaxi.com/";
export { telegramApi, telegramChatId, netbixTelegramApi, netbixTelegramChatId, customerMobileNumber, front_url };